import { useQuery } from "@tanstack/react-query";
import { deliveryChargesService } from "../../services/deliveryChargesService";

export const useDeliveryCharges = () => {
  return useQuery({
    queryKey: ['delivery-charges'],
    queryFn: () => deliveryChargesService.getDeliveryCharges(),
  });
};